import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AlmacenService } from 'src/app/services/api/almacen.service';
import Swal from 'sweetalert2';
import { DialogAsignarTiposComponent } from '../../egreso-equipos/dialog-asignar-tipos/dialog-asignar-tipos.component';
import { FileService } from 'src/app/services/api/file.service';

@Component({
  selector: 'app-dialog-asignar-equipos-file',
  templateUrl: './dialog-asignar-equipos-file.component.html',
  styleUrls: ['./dialog-asignar-equipos-file.component.css']
})
export class DialogAsignarEquiposFileComponent implements OnInit {

  loading:boolean=true;

  dataSource=new MatTableDataSource();

  articulos:any;

  displayedColumns: string[] = [
    'Check',
    'codigo',
    'valoracion',
    'observacion'

  ];

  oldEgresos:any
  
/*   @ViewChild(MatPaginator) paginator!: MatPaginator; */

@ViewChild(MatPaginator) set paginator(value: MatPaginator) {
  this.dataSource.paginator = value;
}

  constructor(private almacenService: AlmacenService,@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<DialogAsignarTiposComponent>) { }

  ngOnInit(): void {
    this.getAllEquiposByEquipoId()
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.dataSource.data.map((fila: any) => {
        fila.selected = false;
      });
      return;
    } else {
      this.dataSource.data.map((fila: any) => {
        fila.selected = true;
      });
      return;
    }
  }

  isAllSelected() {
    let lst: any[];
    lst = this.dataSource.data.filter((x: any) => x.selected == true);
    const numSelected = lst.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  updateCheck(row: any) {
    console.log(row)
    row.selected = !row.selected;

  }

  getAllEquiposByEquipoId() {
    console.log("this.data", this.data)
    console.log("this.data.item", this.data.item)
    this.almacenService.getAllEquiposByEquipoId(this.data.item.agrupadoInfo.equipoId).subscribe((response) => {
    
      //this.oldData = JSON.parse(JSON.stringify(filterCantPax));
      this.articulos = response.getAllEquiposByEquipoId;

      console.log("articulos:::",this.articulos)

      this.almacenService.getAllEgresoEquiposByFileAndProductIdAndEquipoId(this.data.item.itineraryId,this.data.item.productId,this.data.item.agrupadoInfo.equipoId).subscribe((res:any)=>{

        this.oldEgresos=res.getAllEgresoEquiposByFileAndProductIdAndEquipoId

        // console.log(this.oldEgresos)

        this.oldEgresos.map((egreso:any)=>{
          const found=this.articulos.find((el:any)=>el.id===egreso.equipoInventarioId)
          if(found)
            found.selected=true
        })


        this.dataSource.data=this.articulos;
        console.log("talla:::",this.dataSource.data.length)
        this.dataSource.paginator = this.paginator
        this.loading=false
      })


    });

  }

  async closeDialog() {


    console.log(this.oldEgresos)


    const checked=this.dataSource.data.filter((data:any)=>data.selected)

    console.log(checked)

    // Determinar los egresos agregados
    const egresosAgregados = checked.filter((newEgreso:any) => !this.oldEgresos.some((oldEgreso:any) => oldEgreso.id === newEgreso.id));

    // Determinar los egresos eliminados
    const egresosEliminados = this.oldEgresos.filter((oldEgreso:any) => !checked.some((newEgreso:any) => newEgreso.id === oldEgreso.id));

    console.log("Egresos agregados:", egresosAgregados);
    console.log("Egresos eliminados:", egresosEliminados);
    
    
    await Promise.all(
      egresosAgregados.map((el:any)=>{
        this.almacenService.createEgresoEquipo(
          {
            equipoId:el.equipoId,
            equipoInventarioId:el.id,
            fileId:this.data.item.itineraryId,
            fileNumber:this.data.file.fileNumber,
            fileDate:this.data.file.dateRange,
            productId:this.data.item.productId,
            estado:"PROGRAMADO"
          }).toPromise()
      })
    )

    await Promise.all(
      egresosEliminados.map((el:any)=>{
        this.almacenService.deleteEgreso(el.id).toPromise()
      })
    )

    Swal.fire({
      position: 'top-end',
      title: 'Los productos fueron asignados correctamente',
      icon:"success",
      showConfirmButton: false,
      timer: 5000
    }
  )
  this.dialogRef.close(checked.length);



  }

  async closeDialogAssing(){
    const checked=this.dataSource.data.filter((data:any)=>data.selected)
    this.dialogRef.close(checked.length);
  }

}
